import { Directive, ElementRef, NgZone, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appDragScroll]',
  standalone: true,
})
export class DragScrollDirective implements OnInit, OnDestroy {
  private isDragging = false;
  private startX = 0;
  private scrollLeft = 0;
  private wrapper: HTMLElement | null = null;

  private onMouseDown = (e: MouseEvent) => this.handleMouseDown(e);
  private onMouseMove = (e: MouseEvent) => this.handleMouseMove(e);
  private onMouseUp = () => this.handleMouseUp();

  constructor(private el: ElementRef<HTMLElement>, private zone: NgZone) {}

  ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      this.el.nativeElement.addEventListener('mousedown', this.onMouseDown);
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
    });
  }

  ngOnDestroy(): void {
    this.el.nativeElement.removeEventListener('mousedown', this.onMouseDown);
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  }

  private handleMouseDown(e: MouseEvent): void {
    const wrapper = (e.target as HTMLElement).closest('.table-responsive-wrapper') as HTMLElement;
    if (!wrapper) return;

    // Solo activar si la tabla desborda horizontalmente
    if (wrapper.scrollWidth <= wrapper.clientWidth) return;

    this.isDragging = true;
    this.wrapper = wrapper;
    this.startX = e.pageX;
    this.scrollLeft = wrapper.scrollLeft;
    wrapper.style.cursor = 'grabbing';
    wrapper.style.userSelect = 'none';
    e.preventDefault();
  }

  private handleMouseMove(e: MouseEvent): void {
    if (!this.isDragging || !this.wrapper) return;
    const dx = e.pageX - this.startX;
    this.wrapper.scrollLeft = this.scrollLeft - dx;
  }

  private handleMouseUp(): void {
    if (!this.isDragging || !this.wrapper) return;
    this.wrapper.style.cursor = '';
    this.wrapper.style.userSelect = '';
    this.isDragging = false;
    this.wrapper = null;
  }
}
